import { useTranslation } from '@dreamstack/i18n'
import { SimpleModal } from '@dreamstack/simple-components/src/lib/SimpleModal'
import type { FunctionComponent } from 'react'
import { SimpleMuiButton } from '../layout/SimpleMuiButton'

export const SuccessDialog: FunctionComponent<
  React.PropsWithChildren<{
    title?: string
    text: string
    open: boolean
    onHandleClose: CallableFunction
    onCtaClick?: CallableFunction
    ctaLabel?: string
  }>
> = ({ title, text, open, onHandleClose, ctaLabel, onCtaClick }) => {
  const t = useTranslation()
  ctaLabel = ctaLabel ?? t('accentro:continue')
  return (
    <SimpleModal
      open={open}
      handleClose={() => onHandleClose()}
      title={title ?? ''}
      intro={text}
    >
      {ctaLabel && (
        <div className="mb-0">
          <div className="flex gap-px-16 flex-row flex-wrap">
            <SimpleMuiButton
              variant="contained"
              color="primary"
              onClick={async () => {
                onCtaClick && onCtaClick()
                onHandleClose()
              }}
            >
              {ctaLabel}
            </SimpleMuiButton>
          </div>
        </div>
      )}
    </SimpleModal>
  )
}
